// Spec-faithful placeholders. Final assets are a one-line swap here — no layout change.
export const ASSETS = {
  heroVideo: "",
  heroPoster: "",
  erlebnisImage: "/images/barfuss-gehen.png",
  portraitImage: "/images/michael-portrait.png",
};
